import { createSelector } from 'reselect';
import { connect } from 'react-redux';
import FrameworkUtils from 'utils/framework';
import { userSelector } from 'selectors/user/userSelector';
import basketSelector from 'selectors/basket/basketSelector';
import { rougeExclusiveRewardsSelector } from 'selectors/rougeRewards/rougeExclusiveRewardsSelector';
import userUtils from 'utils/User';
import rougeExclusiveUtils from 'utils/rougeExclusive';
import RougeRewardsActions from 'actions/RougeRewardsActions';
import localeUtils from 'utils/LanguageLocale';
import RougeOnlyRewardsEN from 'components/Content/BeautyInsider/RougeOnlyRewards/locales/RougeOnlyRewards_en_US';
import RougeOnlyRewardsFR from 'components/Content/BeautyInsider/RougeOnlyRewards/locales/RougeOnlyRewards_fr_CA';
import Empty from 'constants/empty';

const { wrapHOC } = FrameworkUtils;

const getText = localeUtils.getLocalisedDataFromResource(RougeOnlyRewardsEN, RougeOnlyRewardsFR);

const fields = createSelector(userSelector, basketSelector, rougeExclusiveRewardsSelector, (user, basket, rougeExclusive) => {
    const allRewards = rougeExclusive.rougeExclusiveRewards || Empty.Array;
    const availableRewards = allRewards
        .filter(r => !r.isOutOfStock)
        .map(r => ({
            ...r,
            listPrice: typeof r.listPrice === 'string' ? r.listPrice.toLowerCase() : r.listPrice
        }));

    return {
        isAnonymous: user.isInitialized && userUtils.isAnonymous(),
        isRougeExclusive: rougeExclusiveUtils.isRougeExclusive(),
        user,
        basket,
        availableRewards,
        localization: {
            sectionTitle: getText('sectionTitle'),
            rougeBadge: getText('rougeBadge')
        }
    };
});

const functions = dispatch => ({
    loadRougeRewards: (language, locale) => dispatch(RougeRewardsActions.loadRougeRewards(language, locale))
});

const withRougeOnlyRewardsProps = wrapHOC(connect(fields, functions));

export {
    withRougeOnlyRewardsProps, fields, functions
};
